module.exports = __webpack_public_path__ + "img/179947.8b141461.png";